import { type JSX } from 'react'
import { SHELF_RENDER_TYPE } from '@/features/shared/constants/shelves'
import { GridLayoutContainer } from '@/features/shared/styles/layout'
import { range } from '@/features/shared/utils/range'
import { Column, Row } from '@shipt/design-system-layouts'
import { Skeleton } from '@shipt/design-system-loading'
import { screenSizes } from '@shipt/design-system-themes'
import styled from 'styled-components'

const ProductLoaderWrapper = styled(Row)`
  overflow: hidden;
`

const LoaderLayoutContainer = styled(GridLayoutContainer)`
  margin-bottom: 1rem;

  @media ${screenSizes.tablet} {
    margin-bottom: 1.5rem;
  }
`

const BannerLoader = () => <Skeleton height={200} />

const shelfLoaders = {
  [SHELF_RENDER_TYPE.PRODUCT]: (
    <ProductLoaderWrapper spacing="lg">
      {range(6).map((el) => (
        <Column spacing="md" margin={['md', 0]} key={el}>
          <Skeleton height={150} width={155} />
          <Skeleton height={30} width={80} />
          <Skeleton height={30} width={150} />
        </Column>
      ))}
    </ProductLoaderWrapper>
  ),
  [SHELF_RENDER_TYPE.FEATURED_PROMOTIONS]: (
    <Row spacing="lg">
      <Skeleton width={416} height={124} />
      <Skeleton width={416} height={124} />
      <Skeleton width={416} height={124} />
    </Row>
  ),
  [SHELF_RENDER_TYPE.CAMPAIGN_PROMOS]: <BannerLoader />,
  [SHELF_RENDER_TYPE.BUY_AGAIN_SINGLE_RETAILER]: <BannerLoader />,
} satisfies Record<SHELF_RENDER_TYPE, JSX.Element>

export const getShelfLoader = (shelf: SHELF_RENDER_TYPE) => {
  return () => <LoaderLayoutContainer>{shelfLoaders[shelf]}</LoaderLayoutContainer>
}

export const CMSLoaderPage = ({ types }: { types: SHELF_RENDER_TYPE[] }) => (
  <>
    {range(types.length).map((type) => {
      const typeToUse = types[type]
      if (!typeToUse) return null
      return <LoaderLayoutContainer key={type}>{shelfLoaders[typeToUse]}</LoaderLayoutContainer>
    })}
  </>
)
